<template>
  <div>
    <br />
    <h3 class="text-center">Material</h3>
    <br />
    <b-table :items="items" :fields="fields">
      <template #cell(status)="{ value }">
        <status-indicator :status="value" pulse />
      </template>
    </b-table>
    <br />
    <div v-if="allCylinders.length > 0">
      <b-form-input
        v-model="orderName"
        maxlength="64"
        placeholder="Name der Bestellung (optional)"
      ></b-form-input>
      <div class="mt-3 text-center">
        <button class="btn btn-success" @click="buyWithLoading">
          Bestellen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PRODUCE_ITEM } from "../../constants/graphql";
import { EventBus } from "../../main";

export default {
  name: "ConfigurationSummary",
  data() {
    return {
      fields: [
        { key: "height", label: "Größe [mm]", class: "text-center" },
        { key: "color", label: "Farbe", class: "text-center" },
        { key: "amount", label: "Anzahl", class: "text-center" },
        { key: "status", label: "Lieferstatus", class: "text-center" },
      ],
      orderName: "",
    };
  },
  methods: {
    buyWithLoading() {
      this.$swal({
        title: "Bestellung wird übertragen",
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          this.$swal.showLoading();
        },
      });
      setTimeout(() => {
        this.buy();
      }, 1500);
    },
    buy() {
      const result = this.$apollo
        .mutate({
          mutation: PRODUCE_ITEM,
          variables: {
            order: {
              orderName: this.orderName,
              leftStack: this.mapCylinderInput(this.leftCylinders),
              rightStack: this.mapCylinderInput(this.rightCylinders),
            },
          },
        })
        .then((result) => {
          if (result.data.produce.code == 0) {
            this.$swal({
              title: "Erfolg",
              text: result.data.produce.msg,
              icon: "success",
            }).then(function() {
              EventBus.$emit("onSuccessfulOrder");
            });
          } else {
            this.$swal("Fehler", result.data.produce.msg, "error");
          }
        })
        .catch((error) => {
          this.$swal("Fehler", String(error), "error");
        });
    },

    mapCylinderInput(cylinderStack) {
      var i = 0;
      return cylinderStack.map((cylinder) => ({
        color: {
          r: cylinder.color.r,
          g: cylinder.color.g,
          b: cylinder.color.b,
          name: cylinder.color.name,
        },
        height: cylinder.height,
        position: i++,
      }));
    },

    countHeight(cylinders, height) {
      return cylinders.filter((c) => c.height == height).length;
    },

    countColorByHeight(cylinders, height, colorName) {
      var result = cylinders.filter(
        (c) => c.height == height && c.color.name == colorName
      ).length;
      return result;
    },

    filledColors: function(height) {
      return new Set(
        this.allCylinders
          .filter((cylinder) => cylinder.height == height)
          .map((cylinder) => cylinder.color.name)
      );
    },

    getAvailability(height, color, amount) {
      if (this.getImmediateAvailable(height, color) >= amount) {
        return "positive";
      }
      if (
        this.getImmediateAvailable(height, color) +
          this.getIntermediateStockAvailable(height, color) >=
        amount
      ) {
        return "intermediary";
      }
      return "negative";
    },

    getImmediateAvailable(height, color) {
      for (var i = 0; i < this.stock.immediateStock.length; i++) {
        var stockItem = this.stock.immediateStock[i];
        if (stockItem.height == height && stockItem.color == color) {
          return stockItem.available;
        }
      }
      return 0;
    },

    getIntermediateStockAvailable(height, color) {
      for (var i = 0; i < this.stock.intermediateStock.length; i++) {
        var stockItem = this.stock.intermediateStock[i];
        if (stockItem.height == height && stockItem.color == color) {
          return stockItem.available;
        }
      }
      return 0;
    },
  },
  computed: {
    ...mapGetters([
      "settings",
      "leftCylinders",
      "rightCylinders",
      "allCylinders",
      "stock",
    ]),

    filledHeights: function() {
      return new Set(
        this.settings.cylinders
          .filter(
            (cylinder) =>
              this.countHeight(this.allCylinders, cylinder.height) > 0
          )
          .map((cylinder) => cylinder.height)
      );
    },
    items: function() {
      var result = [];
      for (var height of this.filledHeights) {
        for (var color of this.filledColors(height)) {
          var amount = this.countColorByHeight(
            this.allCylinders,
            height,
            color
          );
          result.push({
            height: height,
            color: color,
            amount: amount,
            status: this.getAvailability(height, color, amount),
          });
        }
      }
      return result;
    },
  },
};
</script>
